import React from 'react';
import '../SalesOrder.css';
import CustomerAddress from './CustomerAddress';
import CustomerAddressChangeMenuContainer from '../containers/CustomerAddressChangeMenuContainer';

const CustomerDetailWrapper = ({
  selectedCustomer,
  customerAddress,
  isCustomerShppingAddressSelectorOpen,
  openCustomerShppingAddressSelector,
  closeCustomerShppingAddressSelector,
  isCustomerBillingAddressSelectorOpen,
  openCustomerBillingAddressSelector,
  closeCustomerBillingAddressSelector,
  selectedShippingAddress,
  selectedBillingAddress,
  setSelectedBillingAddress,
  setSelectedShippingAddress,

  patchAddressRequest,

  closeAddressSelector,
  isCustomerAddressSelectorOpen,
  openCustomerAddressSelector,
  header,
  selectedAddress,
  setSelectedgAddress,

  fields,
}) => {
  const onAddressSelect = (address) => {
    patchAddressRequest(
      {
        active: 1,
      },
      address.id
    );
    setSelectedgAddress(address);
    closeAddressSelector();
  };

  return (
    <div className="CustomerDetail">
      <div style={{ flex: '2 1', position: 'relative' }}>
        <CustomerAddress
          {...selectedAddress}
          header={header}
          customerName={selectedCustomer.Name}
          isEditable={true}
          editOnClick={openCustomerAddressSelector}
        />
        {isCustomerAddressSelectorOpen && selectedCustomer.Name ? (
          <CustomerAddressChangeMenuContainer
            fields={fields}
            AccountID={selectedCustomer.AccountID}
            closeCustomerShppingAddressSelector={closeAddressSelector}
            onAddressSelect={onAddressSelect}
          />
        ) : null}
      </div>
      {/* <div style={{ flex: "2 1", position: "relative" }}>
        <CustomerShippingAdress
          {...selectedShippingAddress}
          customerName={selectedCustomer.Name}
          openCustomerShppingAddressSelector={openCustomerShppingAddressSelector}
          isEditable={true}
          editOnClick={openCustomerShppingAddressSelector} />
        {
          isCustomerShppingAddressSelectorOpen && selectedCustomer.Name ?
            (<CustomerAddressChangeMenuContainer
              fields={fields}
              AccountID={selectedCustomer.AccountID}
              closeCustomerShppingAddressSelector={closeCustomerShppingAddressSelector}
              onAddressSelect={onShippingAddressSelect}
              />) : null
        }
      </div> */}
    </div>
  );
};

export default CustomerDetailWrapper;
